import { useState } from "react";

import { Button } from "@/shared/ui/button";
import { Input } from "@/shared/ui/input";
import { Label } from "@/shared/ui/label";

type Props = {
  amount: number;
  onChange: (value: number) => void;
};

export const ExpenseCalculator = ({ amount, onChange }: Props) => {
  const [delta, setDelta] = useState(100);

  const updateAmount = (delta: number) => {
    onChange(Math.max(0, amount + delta));
  };

  return (
    <div className="flex items-center justify-between gap-6">
      <div>
        <Label>Итоговая сумма | Траты</Label>
        <div className="flex items-center gap-2">
          <Input
            type="text"
            value={amount === 0 ? "" : amount.toString()}
            onChange={(e) => {
              e.target.value = e.target.value.replace(/\D/g, "");
              onChange(Number(e.target.value));
            }}
          />
          <Button
            variant="ghost"
            type="button"
            onClick={() => onChange(0)}
            className="h-10 bg-red-100 text-red-500"
          >
            Обнулить
          </Button>
        </div>
      </div>
      <div>
        <Label>Добавить/отнять траты</Label>
        <div className="flex items-center gap-2">
          <Button
            className="h-10 w-16 text-lg"
            type="button"
            onClick={() => updateAmount(-delta)}
          >
            -
          </Button>
          <Input
            value={delta === 0 ? "" : delta.toString()}
            onChange={(e) => {
              e.target.value = e.target.value.replace(/\D/g, "");
              setDelta(Number(e.target.value));
            }}
            className="text-center"
          />
          <Button
            className="h-10 w-16 text-lg"
            type="button"
            onClick={() => updateAmount(delta)}
          >
            +
          </Button>
        </div>
      </div>
    </div>
  );
};
